import moment from 'moment';

// Support both seconds and milliseconds
const formatUnixTimeStampAsDisplayString = (timestamp: number) => {
  // If timestamp is in milliseconds (e.g., > 10^12), use as-is. Otherwise, multiply by 1000.
  const ms = timestamp > 1e12 ? timestamp : timestamp * 1000;
  return moment(ms).format('MMMM Do, h:mma');
};

export default formatUnixTimeStampAsDisplayString;
